import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'

export class TmAuthInvalidEmailError extends TmAuthError {}
